import {buildPermissions} from '#services/permissions'

export default function (state, payload) {
  const {role} = payload

  if (role) {
    const permissions = buildPermissions({role})

    return {
      ...permissions,
    }
  }

  return null
}
